import { ProgressBar } from 'primereact/progressbar';
import { FC, useEffect, useState } from 'react';
import { useCooldown } from '../../contexts/RetakeCountdownContext';

interface Props {
  skillCode: string;
  width?: string;
  background?: string;
}

const RetakeCountdownBar: FC<Props> = ({ skillCode, width = '40%', background = '#ced4da' }) => {
  const ctx = useCooldown();
  const total = ctx?.getTotalCooldownTime(skillCode) || 1;
  const [elapsed, setElapsed] = useState(0);
  const [remaining, setRemaining] = useState(ctx?.getRemainingTime(skillCode));

  const formatTime = (ms: number) => {
    const seconds = Math.ceil(ms / 1000);
    if (seconds >= 60) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    }
    return `${seconds} second${seconds !== 1 ? 's' : ''}`;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = ctx?.getRemainingTime(skillCode) || 0;
      setRemaining(remainingTime);
      setElapsed(total - remainingTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [skillCode, total, ctx]);

  useEffect(() => {
    if (remaining === 0) {
      ctx?.setRemainingDone(skillCode);
    }
  }, [remaining, ctx]);

  if (remaining === undefined || remaining <= 0) return null;

  return (
    <>
      <div className=" tw-flex tw-flex-col tw-items-center tw-p-4 tw-gap-2">
        <span className="tw-font-atkinson">
          Reattempt in <span className="tw-font-bold">{formatTime(remaining)}</span>
        </span>
        <ProgressBar
          style={{ backgroundColor: `${background}` }}
          className={`tw-w-[${width}] tw-rounded-2xl tw-h-[11px]`}
          pt={{ value: { className: '!tw-rounded-r-2xl !tw-bg-blue-500' } }}
          value={(elapsed / total) * 100}
          showValue={false}
          aria-label="progressbar"
          aria-labelledby="progressbar"
        />
      </div>
    </>
  );
};

export default RetakeCountdownBar;
